import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "@frameworks/salesjourney/stylesheets/components/Features/LeadGenerate/lead.scss";
import "@frameworks/shared-library/assets/scss/variables/fontFamily.scss";
import "@frameworks/shared-library/assets/icons/edel_icons/style.scss";
import Client from "./Client";
import ClientOwners from "./ClientOverview/ClientOwners/ClientOwners";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import DashboardHOC from "@frameworks/salesjourney/components/HOC/DashboardHOC";
var ClientDetailsRouting = function () {
    useEffect(function () {
        var selected = localStorage.getItem("client360SelectedClient");
        if (selected) {
            var selectedObj = JSON.parse(selected);
            if (!!selectedObj &&
                selectedObj !== null &&
                selectedObj !== undefined &&
                (selectedObj === null || selectedObj === void 0 ? void 0 : selectedObj.isPartner)) {
                di.partnerOverview.setSelectedPartner(selectedObj);
            }
            else
                di.clients.setSelectedClientOnSearchClick(JSON.parse(selected));
        }
    }, []);
    return (React.createElement("div", { className: "d-flex dashboard-primary-container" },
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/:clienttabname", element: React.createElement(DashboardHOC, { component: Client, allowRatingFunctionCall: false }) }),
            React.createElement(Route, { path: "/clientoverview/", element: React.createElement(DashboardHOC, { component: ClientOwners, allowRatingFunctionCall: false }) }))));
};
export default ClientDetailsRouting;
